import { Box } from "@mui/material";
import { clone, isNil, max, min } from "lodash";
import { DragEvent, useEffect, useState } from "react";
import GossipStoneBarren from "../../core/assets/oot/classic/OoT_Gossip_Stone_Barren_Model.png";
import GossipStone from "../../core/assets/oot/classic/OoT_Gossip_Stone_Model.png";
import GossipStoneWoth from "../../core/assets/oot/classic/OoT_Gossip_Stone_Woth_Model.png";
import { useOnClickOutside } from "../../core/hook/event/OnClickOutsideHook";
import { OotItemDto } from "./OotItemAutocomplete";
import Deadge from "../../core/assets/oot/classic/deadge.png"
import { MixedPoolLabel } from "../inventory/medallions/MedallionItem";
import GenericModal from "../../core/components/base/GenericModal";
import { ReworkDragDropItemTracker } from "../tracker/ReworkitemTracker";

interface OotItemContextMenuButtonProps {
    barren?: boolean
    woth?: boolean
    item?: OotItemDto | null,
    onItemChange?: (item: OotItemDto | null) => void,
    dead?: boolean
    width?: string,
    height?: string
}

const OotItemContextMenuButton = (props: OotItemContextMenuButtonProps) => {

    let [item, setItem] = useState<OotItemDto | null>(props.dead ? {img: Deadge, name: "Dead", tags: ["dead"] } : isNil(props.item) ? null : props.item)
    let [anchorElement, setAnchorEl] = useState<null | HTMLElement>(null);
    let [open, setOpen] = useState(false);


    useOnClickOutside(anchorElement, () => setOpen(false))

    const handleSelection = (item: OotItemDto | null) => {
        setItem(item);
        setAnchorEl(null);
        setOpen(false)

        if (!isNil(props.onItemChange))
            props.onItemChange(item);
    }

    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault()

        if(props.dead)
            return;
        setItem(null);


        if (!isNil(props.onItemChange))
            props.onItemChange(null);
    }

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {

        setOpen(true)

    }

    const onWheelClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {

        if(isNil(item) || props.dead)
            setItem({img: Deadge, name: "Dead", tags: ["dead"] })
        else if(item.name === "Dead")
            setItem(null)
    }

    const onDrop = (e: DragEvent<HTMLDivElement>) => {

        let dropValue = e.dataTransfer.getData('text/plain');

        const item: OotItemDto = JSON.parse(dropValue)

        console.log("drop")
        if(props.dead && item?.name !== "Bombchus" && item?.name !== "Biggoron's Sword" && item?.name !== "Dead" && item?.name.toLowerCase().includes("key"))
            return;


        setItem(item);

        if (!isNil(props.onItemChange))
            props.onItemChange(item);
    }

    const onDrag = (e: DragEvent<HTMLDivElement>) => {
        if(!isNil(item))
        e.dataTransfer.setData("text/plain", JSON.stringify(item))
    }



    useEffect(() => {

        if(props.dead && item?.name !== "Bombchus" && item?.name !== "Biggoron's Sword" && item?.name !== "Dead")
        {
            setItem({img: Deadge, name: "Dead", tags: ["dead"] })
        }
        else{
            setItem(null)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.dead])

    let width = isNil(props.width) ? "30px" : props.width;
    let height = isNil(props.height) ? "30px" : props.height;

    let altItem = !isNil(props.item) ? props.item : item;

    return <Box component="div" display="flex" onAuxClick={onWheelClick} onDragOver={(e) => { e.preventDefault(); }} onDragEnter={(e) => { e.preventDefault(); }}  onDragStart={onDrag}  onDropCapture={(e) => { console.log("drop capture") }} onDrop={(e) => onDrop(e)} >
        {isNil(altItem)   && <Box onClick={handleClick} onContextMenu={handleRightClick}  onDragStart={onDrag}>
            <img src={props.barren ? GossipStoneBarren : props.woth ? GossipStoneWoth : GossipStone} width={width} height={height} alt="item" /></Box>}
        {!isNil(altItem) && isNil(altItem.altString) && <Box onClick={handleClick} onContextMenu={handleRightClick}  onDragStart={onDrag}> {!isNil(altItem) && <Box onClick={handleClick} onContextMenu={handleRightClick}><img src={altItem.img} width={width} height={height} alt={altItem.name} /></Box>}</Box>}
        {!isNil(altItem) && !isNil(altItem.altString) && <Box onClick={handleClick} onContextMenu={handleRightClick}  onDragStart={onDrag}>{altItem.altString}</Box>}

        <GenericModal handleClose={() => setOpen(false)} open={open}>
            <ReworkDragDropItemTracker left={0} top={0} onSelectItem={(v) => handleSelection(v)} />
        </GenericModal>
    </Box>
}

export default OotItemContextMenuButton;

export interface ItemContextLabelizedDto {
    item: OotItemDto | null,
    sphere?: number,
    labelIndex?: number
}

export const DefaultItemContextLabelizedDto: ItemContextLabelizedDto = clone({
    item: null,
    sphere: 0,
    labelIndex: 0
})

interface OotItemContextMenuLabellizedButtonProps {
    barren?: true
    itemcontext?: ItemContextLabelizedDto
    setItemContext?: (item: ItemContextLabelizedDto) => void 
}
export const OotItemContextMenuLabellizedButton = (props: OotItemContextMenuLabellizedButtonProps) => {

    let [index, setIndex] = useState(props.itemcontext?.labelIndex ?? 0);

    let labels = MixedPoolLabel.filter(x => !["MKT_Bridge", "LW_Bridge"].includes(x.label));
    
    const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
        e.preventDefault();
        let index = 0;
        if (e.deltaY > 0 && index === 0)
            index = labels.length - 1        
        else if (e.deltaY > 0)
            index = max([0, index - 1]) ?? 0
        else if (e.deltaY > 0 && index === labels.length - 1) {
            index = 0;
        }
        else if (e.deltaY < 0 && index === labels.length - 1)
            index = 0
        else if (e.deltaY < 0)
            index = min([labels.length - 1, index + 1]) ?? 0
        else
            index = labels.length - 1;

        setIndex(index)
        if(!isNil(props.setItemContext))
            props.setItemContext({...props.itemcontext, labelIndex: index} as ItemContextLabelizedDto)
    }

    const onDrop = (e: DragEvent<HTMLDivElement>) => {

        // console.log("", e.dataTransfer)
        let result = e.dataTransfer.getData('text/plain');

        if(!result.includes("\"img\":")){
            let index = labels.indexOf(labels.filter(x => x.label.toLocaleLowerCase() === result.toLocaleLowerCase())?.[0] ?? 0)

            setIndex(index)

            if(!isNil(props.setItemContext))
                props.setItemContext({...props.itemcontext, labelIndex: index} as ItemContextLabelizedDto)
        }
    }

   
    return <Box width={40} onWheel={handleWheel} display={"flex"} position={"relative"} onContextMenu={(e) => {e.preventDefault(); setIndex(0)}} onDrop={onDrop}>
        <OotItemContextMenuButton {...props} item={props.itemcontext?.item} onItemChange={(v) => {if(!isNil(props.setItemContext))
                props.setItemContext({...props.itemcontext, item: v} as ItemContextLabelizedDto)} } />
        {index !==0 && <Box width={40} textAlign={"center"} position={"absolute"} top={20} left={-5} >{labels?.[index]?.label ?? ""}</Box>}
    </Box>
}